import type { ContentObjectDetail, ContentObjectList } from 'models';
import { copyToClipboard, generateURL } from '../utils';
import { generateContentObjectPath } from './generate-content-object-path';

const generateContentObjectURL = (item: ContentObjectDetail | ContentObjectList) => {
  const path = generateContentObjectPath(item);
  return generateURL(path);
};

export const copyLinkToClipboard = async (item: ContentObjectDetail | ContentObjectList) =>
  // eslint-disable-next-line @typescript-eslint/require-await -- Async is required by iOS interface, do not work without it
  copyToClipboard(async () => generateContentObjectURL(item));
